import { AJAX_WP_Query } from 'ajax-wp-query';
import './components/index';
let form = document.querySelector('.template-end__form');
let formBr = form.querySelectorAll('br');

formBr.forEach(function (br) {
    br.parentNode.removeChild(br);
});